import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useKidMode } from '../contexts/KidModeContext'
import { isKidBlockedPath } from '../lib/kidRoutes'

interface KidRouteGuardProps {
  children: ReactNode
}

/** Redirects kid-mode users away from adult-only routes. */
export function KidRouteGuard({ children }: KidRouteGuardProps) {
  const { isKidMode } = useKidMode()
  const location = useLocation()

  if (isKidMode && isKidBlockedPath(location.pathname)) {
    const redirectTo = location.pathname.startsWith('/games/') ? '/games' : '/'
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
